import { theme } from "../../theme";
import ScrollHint from "../ui/ScrollHint";

export default function BottomNav({ activeTab, unreadCount, goFeed, goSearch, goNewJob, goCalendar, goMyPage }) {
  const tabs = [
    { id: "feed", icon: "🏠", label: "Verk", action: goFeed },
    { id: "search", icon: "🔍", label: "Leita", action: goSearch },
    { id: "new", icon: "➕", label: "Nýtt", action: goNewJob, special: true },
    { id: "calendar", icon: "📅", label: "Dagatal", action: goCalendar },
    { id: "mypage", icon: "👤", label: "Ég", action: goMyPage, badge: unreadCount },
  ];

  return (
    <>
    <ScrollHint />
    <nav role="navigation" aria-label="Aðalvalmynd" style={{ position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: 480, background: theme.surface, borderTop: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-around", padding: "8px 0 20px", zIndex: 100 }}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={tab.action}
          aria-label={tab.label}
          aria-current={activeTab === tab.id ? "page" : undefined}
          style={{
            background: tab.special ? `linear-gradient(135deg, ${theme.accent}, #0ea5e9)` : "none",
            border: "none",
            color: tab.special ? "#0a0f1a" : (activeTab === tab.id ? theme.accent : theme.textDim),
            display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
            fontSize: 10, cursor: "pointer", padding: tab.special ? "8px 20px" : "4px 12px",
            borderRadius: tab.special ? 20 : 0, fontWeight: tab.special ? 700 : 500,
            transform: tab.special ? "translateY(-12px)" : "none",
            boxShadow: tab.special ? `0 4px 20px ${theme.accentGlow}` : "none",
            position: "relative",
          }}
        >
          <span style={{ fontSize: tab.special ? 20 : 22 }}>{tab.icon}</span>
          <span>{tab.label}</span>
          {tab.badge > 0 && (
            <span style={{
              position: "absolute", top: -2, right: 2,
              background: theme.red, color: "white",
              fontSize: 10, fontWeight: 700,
              minWidth: 18, height: 18,
              borderRadius: 9, display: "flex",
              alignItems: "center", justifyContent: "center",
              padding: "0 4px",
            }}>{tab.badge > 99 ? "99+" : tab.badge}</span>
          )}
        </button>
      ))}
    </nav>
    </>
  );
}
